module.exports = __webpack_public_path__ + "images/category_lp/game_console/assessment_achievements/2_cb971334887c9fb9596e8c6f9ef31a69.png";